/**
 * Created by andrey on 21.12.2020.
 */

Unit.CreateHierarchyMenu = function (callback) {
    const menu = {};

    Object.keys(cleverapps.meta.selectedLocationId().families || {}).forEach((code) => {
        if (["unknown", "multiCellBody", "specialoffer"].indexOf(code) !== -1) {
            return;
        }

        const type = Families[code].type || "other";
        const units = {};

        for (let stage = 0; stage < Families[code].units.length; ++stage) {
            const unit = { code, stage };

            units[Unit.GetKey(unit)] = {
                icon: UnitView.getUnitImage.bind(UnitView, unit),
                action: callback.bind(null, unit)
            };
        }

        if (!menu[type]) {
            menu[type] = {};
        }

        menu[type][code] = units;
    });
    return menu;
};

cleverapps.override(cleverapps.Tool, {
    minigame: ToolFolder.create(() => {
        const mineGameSceneComponent = ComponentMap.getByName(cleverapps.Scenes.GetRunningScene(), "MineGameSceneComponent");
        const minigame = mineGameSceneComponent && mineGameSceneComponent.mineGame;
        if (minigame) {
            return {
                win: minigame.win.bind(minigame)
            };
        }
    }),

    UI: {
        windows: {
            levelUpWindow: displayToolWindow(() => {
                new LevelUpWindow();
            }),

            finishQuestWindow: displayToolWindow(() => {
                new FinishQuestWindow(Map2dLocation.currentLocation.quests.quests[0]);
            }),

            speedUpWindow: displayToolWindow(() => {
                const unit = new Unit({
                    code: "wood",
                    stage: 6,
                    unbuilt: true
                });

                const worker = new GameWorker(Map2d.currentMap.workers.chooseFreeSkin());
                worker.setSpeedUpBonus();
                worker.assign(unit, unit.findComponent(Buildable).time);

                new SpeedUpWindow(worker);
            }),

            buyIngredientsWindow: displayToolWindow(() => {
                new BuyIngredientsWindow({
                    hardItems: [
                        { ingredient: "wheat", amount: 10 },
                        { ingredient: "apple", amount: 3 },
                        { ingredient: "candies", amount: 5 }
                    ],
                    softItems: [
                        { ingredient: "strawberry", amount: 5 },
                        { ingredient: "mushrooms", amount: 2 }
                    ],
                    totalHard: 300,
                    totalSoft: 20
                });
            }),

            SpecialEnergyOfferWindow: displayToolWindow(() => {
                new SpecialEnergyOfferWindow();
            }),

            ReceiveWorkerWindow: displayToolWindow(() => {
                new ReceiveWorkerWindow();
            }),

            WarehouseWindow: displayToolWindow(() => {
                new WarehouseWindow();
            }),

            MergeGuideWindow: displayToolWindow(() => {
                if (bundles.merge_guide_window) {
                    new GuideWindow({
                        name: "MergeGuideWindow",
                        bundle: bundles.merge_guide_window,
                        closeButtonDelay: true
                    });
                }
            }),

            CharacterUnlockedWindow: displayToolWindow(() => {
                const rewards = new RewardsList({ exp: 150, soft: 10, energy: 30 }, {
                    event: cleverapps.EVENTS.EARN.OTHER
                });
                const unit = new Unit({ code: "elf", stage: 6 });
                rewards.receiveRewards();

                new CharacterUnlockedWindow({
                    unit,
                    rewards
                });
            })
        }
    },

    game: {
        win: undefined,
        lose: undefined,

        stop_saving: function () {
            connector.dataLoader.setEnabled(false);
            cleverapps.dataLoader.setEnabled(false);
        },

        tutorial: ToolFolder.create(() => {
            const menu = {};

            menu.finishAll = function () {
                Map2dLocation.currentLocation.tutorial.finishAll();
                cleverapps.tutorial.stop();

                Map2dLocation.currentLocation.quests.quests = Map2dLocation.currentLocation.quests.quests.filter((quest) => !quest.getTutorial());
                Map2dLocation.currentLocation.quests.save();
            };

            if (typeof MergeTutorials !== "undefined") {
                for (const id in MergeTutorials) {
                    menu[id] = function (id) {
                        cleverapps.focusManager.display({
                            focus: "quests",
                            action: function (f) {
                                Map2dLocation.currentLocation.tutorial.showTutorial(MergeTutorials[id], f);
                            }
                        });
                    }.bind(null, id);
                }
            }

            return menu;
        }),

        toggleAnchorsMode: {
            flag: "keyboardAnchorsMode"
        },

        toggleNodeDebugPanel: {
            flag: "nodeDebugPanelMode"
        },

        hideUI: function () {
            cleverapps.gameModes.noSidebar = true;
            Map2dLocationSceneComponent.prototype.hasExtraBar = function () {
                return false;
            };
            cleverapps.gameModes.noUpMenu = true;

            cleverapps.Tool.Debug.screenshots();
        },

        makeUnknown: ToolFolder.create(() => {
            const menu = {};

            menu.clear = function () {
                cleverapps.dataLoader.remove(DataLoader.TYPES.UNKNOWN_UNIT_TEST);
                cleverapps.dataLoader.processSaveQueue();
                setTimeout(window.location.reload.bind(window.location), 0);
            };

            Object.keys(cleverapps.meta.getSelectedLocation().families || {}).forEach((code) => {
                menu[code] = {
                    family: function () {
                        cleverapps.dataLoader.save(DataLoader.TYPES.UNKNOWN_UNIT_TEST, {
                            code
                        });
                        cleverapps.dataLoader.processSaveQueue();
                        setTimeout(window.location.reload.bind(window.location), 0);
                    },
                    lastUnit: function () {
                        cleverapps.dataLoader.save(DataLoader.TYPES.UNKNOWN_UNIT_TEST, {
                            code,
                            stage: Families[code].units.length - 1
                        });
                        cleverapps.dataLoader.processSaveQueue();
                        setTimeout(window.location.reload.bind(window.location), 0);
                    }
                };
            });
            return menu;
        }),

        testUnitSaveLogs: function () {
            const slot = Map2d.currentMap.findEmptySlot(0, 0);

            const unit = new Unit({ code: "wood", stage: 3 });
            unit.setPosition(slot.x, slot.y);

            cleverapps.notification.create(`unit created ${unit.code}_${unit.stage}. It will be saved in 15 sec.`);

            setTimeout(() => {
                unit.save();
                cleverapps.notification.create(`unit saved ${unit.code}_${unit.stage}`);
            }, 15 * 1000);
        },

        addUnitToStorage: function () {
            const backpack = Map2dLocation.currentLocation.backpack;

            const index = backpack.findFreeSlot();
            const unit = {
                stage: 0,
                code: "a"
            };

            unit.getType = () => "resource";

            const currentWindow = cleverapps.focusManager.currentWindow();
            const storageView = currentWindow && currentWindow.backpackView;

            if (!backpack.isFull() && backpack.canAcceptUnit(unit)) {
                backpack.insert(index, unit);

                if (storageView) {
                    storageView.addToSlot(unit, index);
                }
            }
        },

        merge2orders: ToolFolder.create(() => ({
            setOrderIndex: function () {
                displayToolPrompt((amount) => {
                    amount = parseInt(amount);
                    if (!isNaN(amount)) {
                        Map2dLocation.currentLocation.orderManager.setOrderIndex(amount);
                    }
                }, "Enter amount", 10);
            },

            showCurrentOrderIndex: function () {
                cleverapps.notification.create(Map2dLocation.currentLocation.orderManager.index, {
                    debugInfo: true
                });
            }
        })),

        nextHero: function () {
            const merge = Map2dLocation.currentLocation;

            const type = cleverapps.unitsLibrary.getExpeditionUnitType("hero");
            const currentHeroCode = cleverapps.unitsLibrary.getCurrentHero(type);
            const activeHeroCode = cleverapps.unitsLibrary.getActiveHero(type);

            const prevHero = cleverapps.unitsLibrary.heroes.filter((unit) => unit.code === activeHeroCode)[0];

            const cell = merge.map.findEmptySlot(prevHero.x, prevHero.y);

            const newHero = new Unit({
                code: currentHeroCode,
                stage: Families[currentHeroCode].units.length - 1
            });

            newHero.setPosition(cell.x, cell.y);
            merge.map.add(Map2d.LAYER_UNITS, newHero.x, newHero.y, newHero);
            merge.map.onAddUnit(newHero.x, newHero.y, newHero);

            cleverapps.unitsLibrary.openUnit(newHero);
        },

        resetBonusWorker: function () {
            Map2d.currentMap.workers.removeBonusWorker();
        },

        resetFreeWorker: function () {
            Map2d.currentMap.workers.freeWorkerLost();
            Map2d.currentMap.workers.removeBonusWorker();
        },

        sendPixels: function () {
            if (cleverapps.unitsLibrary.listAvailableByType("fruit").length || !cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
                Map2dLocation.currentLocation.pixelsPlanner.createSwarm();
            }
        },

        toggleBackgroundDebugInfo: function () {
            if (Map2d.currentMap) {
                Map2d.currentMap.trigger("toggleDebugInfo");
            }
        },

        createOfflineFriendBalloon: function () {
            Map2dLocation.currentLocation.friendPixelsPlanner.createTutorialPixel();
        },

        sendFriendBalloons: function () {
            if (cleverapps.loadedSnapshot && cleverapps.flags.norest) {
                cleverapps.notification.create("This action is unavailable in snapshot");
                return;
            }

            const amount = 10;
            for (let i = 0; i < amount; i++) {
                const friendId = `test_${i}`;

                connector.multi.requests.send(friendId, connector.platform.getUserID(), levels.FriendRequest.TYPE_SENT_UNIT);
            }

            cleverapps.notification.create(`send ${amount} gifts`);
        },

        sendKraken: function () {
            Map2dLocation.currentLocation.monstersPlanner.spawnMonster();
        },

        resetWands: function () {
            Map2dLocation.currentLocation.takeWands(Map2dLocation.currentLocation.wands);
        },

        add10Wands: function () {
            Map2dLocation.currentLocation.addReward("wands", 10);
        },

        add1000Wands: function () {
            Map2dLocation.currentLocation.addReward("wands", 1000);
        },

        energyLottery: {
            reset: function () {
                Map2dLocation.currentLocation.energyLottery.reset();
            },

            resetTimer: function () {
                const lottery = Map2dLocation.currentLocation.energyLottery;
                lottery.last = Date.now() - cleverapps.parseInterval(EnergyLottery.REFRESH_TIMEOUT);
                lottery.save();
                lottery.update();
            }
        },

        quests: ToolFolder.create(() => {
            const quests = Map2dLocation.currentLocation && Map2dLocation.currentLocation.quests || [];
            const menu = {
                repeated: {}
            };

            for (const id in quests.config) {
                const config = quests.config[id];

                if (RepeatedQuests[id]) {
                    menu.repeated[id] = function (config) {
                        if (!config.dynamic || config.dynamic.getUnit && config.dynamic.getUnit()) {
                            quests.startQuests([config]);
                        }
                    }.bind(undefined, config);
                } else {
                    const trigger = config.trigger;
                    const type = id.replace(/_.+/, "") || "other";

                    if (!menu[type]) {
                        menu[type] = {};
                    }

                    menu[type][id] = quests.create.bind(quests, {
                        unit: trigger && trigger.unit,
                        fog: trigger && trigger.fog
                    });
                }
            }

            return menu;
        }),

        stories: ToolFolder.create(() => {
            const menu = {};

            const location = cleverapps.meta.getSelectedLocation();

            const bundle = bundles[`unitstories_${location.locationId}`];
            if (!bundle) {
                return menu;
            }

            const unitStories = bundle.jsons.unitstories_json.resolve().getJson();

            Object.keys(unitStories).forEach((id) => {
                const code = id.split("_")[0];
                const stage = +id.split("_")[1];

                if (code === "fog") {
                    menu[id] = function (id) {
                        Map2dLocation.currentLocation.unitStories.onFogOpened({ id: id.slice("fog_".length) });

                        Map2dLocation.currentLocation.counter.trigger();
                    }.bind(null, id);

                    return;
                }

                if (!location.families[code]) {
                    return;
                }

                if (!menu[code]) {
                    menu[code] = {};
                }

                menu[code][id] = function (id) {
                    const unit = Map2d.currentMap.listAvailableUnits({
                        code,
                        stage
                    })[0];

                    if (unit) {
                        Map2dLocation.currentLocation.unitStories.onUnitOpened(unit);
                    } else {
                        Map2dLocation.currentLocation.unitStories.fresh.push({
                            story: Map2dLocation.currentLocation.unitStories.findStory(id)
                        });
                        Map2dLocation.currentLocation.counter.trigger();
                    }
                }.bind(null, id);
            });
            return menu;
        }),

        thirdElement: ToolFolder.create(() => {
            const spawn = function (type) {
                const map = Map2d.currentMap;

                const sceneComponent = cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent);

                let cell = sceneComponent.innerMap.getCellByCoordinates(sceneComponent.map.getCurrentPosition());
                cell = map.findEmptySlot(cell.x, cell.y);

                const unit = {
                    stage: 4,
                    code: "wood"
                };

                if (cell && unit) {
                    const config = ThirdElement.GetConfig(type, unit);
                    if (!config) {
                        return;
                    }
                    const options = {
                        code: "thirdelement", stage: config.limit !== undefined ? 0 : 1, type, prize: unit
                    };

                    const offer = new Unit(options);

                    offer.setPosition(cell.x, cell.y);
                    map.add(Map2d.LAYER_UNITS, cell.x, cell.y, offer);
                    map.onAddUnit(cell.x, cell.y, offer);
                    offer.findComponent(ThirdElement).onAppearance();
                }
            };

            return {
                ads: spawn.bind(undefined, ThirdElement.TYPE_ADS),
                ruby: spawn.bind(undefined, ThirdElement.TYPE_RUBY)
            };
        }),

        pixelOffer: ToolFolder.create(function () {
            const menu = {};

            if (typeof PixelOfferLogic !== "undefined") {
                for (let i = 0; i < PixelOfferLogic.LEVELS.length; i++) {
                    menu[`stage_${i}`] = function (stage) {
                        let offer = cleverapps.offerManager.findOffer({ type: Offers.TYPES.PIXEL_OFFER });
                        if (!offer) {
                            cleverapps.offerManager.addOffer(Offers.TYPES.PIXEL_OFFER);
                            cleverapps.offerManager.shownOfferTypes[Offers.TYPES.PIXEL_OFFER] = true;
                            offer = cleverapps.offerManager.findOffer({ type: Offers.TYPES.PIXEL_OFFER });
                        }
                        offer.stage = stage;
                        cleverapps.offerManager.save();
                        cleverapps.offerManager.refreshOffer(Offers.TYPES.PIXEL_OFFER);
                    }.bind(this, i);
                }
            }

            return menu;
        }),

        barrel: function () {
            Map2dLocation.currentLocation.barrelPlanner.spawn();
        },

        pocket: {
            clear: function () {
                Map2dLocation.currentLocation.pocket.bubbles.forEach((bubble) => {
                    bubble.remove();
                });
            },

            addUnit: ToolFolder.create(() => Unit.CreateHierarchyMenu((unit) => {
                Map2dLocation.currentLocation.pocket.addUnits(unit);
            }))
        },

        pawbox: {
            clear: function () {
                Map2dLocation.currentLocation.pawBox && Map2dLocation.currentLocation.pawBox.setPoints(0);
            },
            add: function () {
                if (Map2dLocation.currentLocation.pawBox) {
                    const points = parseInt(window.prompt("points", Map2dLocation.currentLocation.pawBox.getPointsLeft()));
                    if (points) {
                        Map2dLocation.currentLocation.pawBox.addPoints(points);
                    }
                }
            }
        },

        storage: {
            resetLevel: function () {
                Map2dLocation.currentLocation.harvested.level = 0;
                Map2dLocation.currentLocation.harvested.save();
                Map2dLocation.currentLocation.harvested.onChange();
            },
            resetItems: function () {
                Map2dLocation.currentLocation.harvested.items = {};
                Map2dLocation.currentLocation.harvested.save();
                Map2dLocation.currentLocation.harvested.onChange();
            }
        },

        location: {
            fogUnitsData: function () {
                const locationName = cleverapps.meta.selectedLocationId();

                const levelData = bundles[`location_${locationName}`].jsons.map_json.resolve().getJson();

                let result = "";

                Object.keys(levelData.regions).sort((a, b) => {
                    const aNumbers = a.match(/\d+/g);
                    const bNumbers = b.match(/\d+/g);
                    const aNumber = aNumbers && parseInt(aNumbers[0]) || 0;
                    const bNumber = bNumbers && parseInt(bNumbers[0]) || 0;
                    if (aNumber > bNumber) {
                        return 1;
                    }
                    if (aNumber < bNumber) {
                        return -1;
                    }
                    return 0;
                }).forEach((fogName) => {
                    result += `\n\n--------- ${fogName} ------------`;
                    const codeWithStage = [];
                    levelData.regions[fogName].positions.forEach((position) => {
                        levelData.field.forEach((unit) => {
                            if (unit.x === position.x && unit.y === position.y) {
                                codeWithStage.push({
                                    code: unit.code,
                                    stage: unit.stage
                                });
                            }
                        });
                    });

                    codeWithStage.sort((a, b) => {
                        const textA = a.code.toUpperCase();
                        const textB = b.code.toUpperCase();
                        return textA.localeCompare(textB) || a.stage - b.stage;
                    });

                    codeWithStage.forEach((unit) => {
                        result += ` \ncode: ${unit.code} stage: ${unit.stage}`;
                    });
                });

                const element = document.createElement("a");
                element.href = URL.createObjectURL(new Blob([result], {
                    type: "text/csv"
                }));
                element.setAttribute("download", `${levelData.location}ResultData.csv`);
                element.style.display = "none";

                document.body.appendChild(element);

                element.click();

                document.body.removeChild(element);
            }
        }
    },

    Debug: {
        customers: ToolFolder.create(function () {
            const customers = {};

            Map2d.currentMap && Map2d.currentMap.listAvailableUnits([{ type: "rpcustomer" }]).forEach((customerUnit) => {
                customers[customerUnit.code] = function () {
                    const customer = customerUnit.findComponent(Customer);

                    const ingredients = {};

                    customer.getCurrentRecipe().ingredients.forEach((ingredient) => {
                        ingredients[`add_${ingredient.unit.code}`] = function () {
                            const sceneComponent = cleverapps.Scenes.GetSceneComponent(Map2dLocationSceneComponent);
                            let cell = sceneComponent.innerMap.getCellByCoordinates(sceneComponent.map.getCurrentPosition());
                            cell = Map2d.currentMap.findEmptySlot(cell.x, cell.y, ingredient.unit, { radius: 0 });
                            if (cell) {
                                const unit = new Unit(ingredient.unit);
                                if (unit.findComponent(Creatable)) {
                                    unit.findComponent(Creatable).state = Creatable.STATE_BUILT;
                                }

                                unit.setPosition(cell.x, cell.y);
                                Map2d.currentMap.add(Map2d.LAYER_UNITS, cell.x, cell.y, unit);
                                Map2d.currentMap.onAddUnit(cell.x, cell.y, unit);
                                Map2d.currentMap.onUnitAvailable(unit);

                                const data = { unit };
                                Map2d.mapEvent(Map2d.SPAWN, data);
                                cleverapps.tutorial.trigger(Map2d.SPAWN, data);
                            }
                        };
                    });

                    ingredients.regenerate = function () {
                        customer.seed = Date.now();
                        customer.unit.save();
                        customer.order();

                        cleverapps.toolModel.refresh();
                        cleverapps.focusManager.closeAllWindows();
                        Map2d.currentMap.customers.showWindow(customer);
                    };

                    return ingredients;
                };
            }, this);

            return customers;
        }),

        finger: ToolFolder.create(() => {
            const getUnits = function () {
                return Map2d.currentMap.listAvailableUnits().sort((a, b) => Map2d.currentMap.getCenterDistance(a) - Map2d.currentMap.getCenterDistance(b));
            };

            return {
                demoTap: function () {
                    FingerView.hintTap(getUnits()[0], { });
                    FingerView.currentFinger.showAnchorPoint();

                    Map2d.currentMap.advice.paused = true;
                },
                demoTapOnce: function () {
                    FingerView.hintTap(getUnits()[0], {
                        runOnce: true
                    });
                    FingerView.currentFinger.showAnchorPoint();
                },
                demoSwipe: function () {
                    const units = getUnits();
                    FingerView.hintSwipe(units[0], units[1]);
                    FingerView.currentFinger.showAnchorPoint();

                    Map2d.currentMap.advice.paused = true;
                },
                demoSwipeOnce: function () {
                    const units = getUnits();
                    FingerView.hintSwipe(units[0], units[1], {
                        runOnce: true
                    });
                    FingerView.currentFinger.showAnchorPoint();
                },
                stopDemo: function () {
                    Map2d.currentMap.advice.paused = false;
                    FingerView.remove(FingerView.currentFinger, true);
                }
            };
        }),

        demo: ToolFolder.create(() => {
            const urls = {};

            cleverapps.meta.listAvailableLocations().forEach((locationId) => {
                urls[locationId] = function () {
                    const url = cleverapps.RestClient.standsWeb(`/?unitsDemo=${locationId}`);
                    connector.platform.openUrl(url);
                };

                const addUnit = function (code, unit) {
                    if (Families[unit] && Families[unit].expeditions.includes(locationId)) {
                        urls[code] = function () {
                            const url = cleverapps.RestClient.standsWeb(`/?unitsDemo=${locationId}&code=${unit}`);
                            connector.platform.openUrl(url);
                        };
                    }
                };

                const battlepassUnit = `${UnitsLibrary.EXPEDITION_PREFIXES[locationId]}battlepass`;
                addUnit(`${locationId}_bp`, battlepassUnit);
                if (locationId === "dragonia3") {
                    cleverapps.rangeArray(1, 5).forEach((stage) => {
                        addUnit(`${locationId}_bp${stage}`, battlepassUnit + stage);
                    });
                }
            });

            return urls;
        }),

        offers: ToolFolder.create(() => {
            const res = {};

            const keyToNameMap = Object.fromEntries(Object.entries(Offers.TYPES).map(([k, v]) => [v, k]));

            Object.entries(cleverapps.offerManager.offers).forEach(([key, offer]) => {
                const timeLeft = offer.logic.getTimeLeft();
                const label = timeLeft === undefined ? keyToNameMap[key] : `${keyToNameMap[key]}  ${cleverapps.intervalToString(timeLeft)}`;
                res[label] = () => {
                    offer.complete();

                    cleverapps.toolModel.refresh();
                };
            });

            return res;
        }),

        toggleDebugClick: {
            flag: "toggleDebugClick"
        },

        checkUnusedEdgesAndBorders: function () {
            const unused = Map2d.currentMap.edges.getUnusedEdges().concat(ViewReader.getUnused());
            if (unused.length > 0) {
                console.warn(`The map has ${unused.length} unused edges/borders from tiles ${Map2d.currentMap.tilesSkin}`);
                console.log(unused.join("\n"));
            } else {
                console.log("The map has no unused edges and borders!");
            }
        }
    }
});
